<template>
  <v-container>
    <page-title title="Help &amp; Feedback" class="text-center" />
    <p class="sub-hero-text text-center mb-7">
      Write to us, lets talk about everything
    </p>
    <v-form>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6">
          <v-text-field
            label="Your name (optional)"
            required
            placeholder="Jane Doe"
            outlined
          ></v-text-field>
          <v-text-field
            label="Your email "
            required
            placeholder="Jane Doe"
            outlined
          ></v-text-field>

          <v-text-field
            label="Your email subject "
            required
            placeholder="Jane Doe"
            outlined
          ></v-text-field>

          <v-textarea
            label="Your email subject "
            required
            placeholder="Jane Doe"
            outlined
          >
          </v-textarea>
          <v-btn
            block
            type="submit"
            class="white--text"
            large
            color="var(--purple)"
          >
            Send <v-icon right>mdi-plane</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <router-view />
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
export default {
  components: { PageTitle },
};
</script>

<style>
</style>